import React, { useEffect } from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import EnquiryDeets from '../../Components/allEnquiresTab/EnquiryDeets'
import Myprofile from '../myprofile/Myprofile'
import { useDispatch, useSelector } from 'react-redux'
import { getBomEnquirydetailsThunk, getExcessEnquirydetailsThunk, getWizardEnquirydetailsThunk } from '../../../../Website/redux/bomSlice'
import { useLocation, useParams } from 'react-router-dom'

const EnquiryDetails = () => {
    const dispatch = useDispatch()
    const { id } = useParams()
    const location = useLocation()
    const from = location.state
    console.log(from);

    const { bomenquirydetails, loading } = useSelector(state => state.bom)

    useEffect(() => {
        if (from == "BOM") {
            dispatch(getBomEnquirydetailsThunk(id))
        } else if (from == "Wizard") {
            dispatch(getWizardEnquirydetailsThunk(id))
        } else {
            dispatch(getExcessEnquirydetailsThunk(id))
        }
    }, [from])


    return (
        <>
            <Myprofile>
                {
                    loading ?
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 10,width:'100%' }}>
                            <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
                        </div>
                        :
                        <EnquiryDeets
                            data={bomenquirydetails}
                            enquiryId={bomenquirydetails?._id}
                            from={from}
                        />
                }

            </Myprofile>
        </>
    )
}

export default EnquiryDetails